import React from 'react'

import { PermissionChecker } from '../../session'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import EditSegmentForm from './EditSegmentForm'
import PageHeader from './PageHeader'
import SegmentationFormHandler from './_form/SegmentationFormHandler'
import SegmentationLoader from './_load/SegmentationLoader'

const EditSegmentPage = ({ id }) => {
  return (
    <AbsolutePageTemplate>
      <PageHeader id={id} />
      <PermissionChecker permission="editSegment" name={!!id ? 'edit' : 'new'}>
        <SegmentationLoader id={id}>
          <SegmentationFormHandler>
            <EditSegmentForm />
          </SegmentationFormHandler>
        </SegmentationLoader>
      </PermissionChecker>
    </AbsolutePageTemplate>
  )
}

export default EditSegmentPage
